import {
  SET_LOCALE,
  FETCH_PAGE_REQUEST,
  FETCH_PAGE_SUCCESS,
  FETCH_PAGE_FAILURE,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  UNLOAD_PAGE,
} from '../actions/types';
import type { RoutesState } from './types';

const initialState: RoutesState = {
  locale: 'de',
  loading: false,
};

export default function routesReducer(state = initialState, action: any): RoutesState {
  switch (action.type) {
    case SET_LOCALE:
      return { ...state, locale: action.locale };
    case FETCH_PAGE_REQUEST:
      return { ...state, loading: action.loading };
    case FETCH_PAGE_FAILURE:
      return { ...state, loading: action.loading, error: true };
    case FETCH_PAGE_SUCCESS:
      return {
        ...state,
        loading: action.loading,
        [action.pageType]: action.data,
        error: false,
      };
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        user: action.data,
      };
    case FETCH_USER_FAILURE:
      return {
        ...state,
        user: initialState.user,
      };
    case UNLOAD_PAGE:
      if (!action.routeName) {
        return state;
      }
      return {
        ...state,
        [action.routeName]: undefined,
      };
    default:
      return state;
  }
}
